<template>
    <ls-modal :options="modals.faq" @onModalClose="closeModal('faq')">
        <div v-if="!isStandAloneTreatment" slot="header">
            <h3 class="ls-align--center ls-color--green">Frequently Asked Questions</h3>
        </div>

        <div class="grid">
            <div class="grid__col-12">
                <div class="ls-faq__wrapper">
                    <lsFAQ
                        v-if="isStandAloneTreatment"
                        :data="questions"
                        :call-support="true"
                        testid="treatment-faq"
                    />
                    <lsFaqList v-else />
                </div>
            </div>
        </div>

        <div v-if="!isStandAloneTreatment" slot="button" class="grid">
            <div class="grid__col-12">
                <div>
                    <button
                        slot="button"
                        class="ls-float-right ls-button ls-button--white"
                        type="button"
                        @click="closeModal('faq')"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    </ls-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import * as types from '@/store/types';
import lsModal from '@/components/original-mydot/modals/modal/Modal.vue';
import lsFaqList from '@/components/general/faqList/FaqList.vue';
import lsFAQ from '@/components/LsFAQ/LsFAQ.vue';
import { serviceType, FAQ_TREATMENT_QUESTIONS } from '@/constants';

export default {
    components: {
        lsModal,
        lsFaqList,
        lsFAQ,
    },
    computed: {
        ...mapState(['modals', 'order']),
        isStandAloneTreatment() {
            return serviceType.TREATMENT === this.order.intent;
        },
        questions() {
            return this.isStandAloneTreatment
                ? FAQ_TREATMENT_QUESTIONS.map(({ title, content }) => ({ title, content }))
                : [];
        },
    },
    methods: {
        ...mapActions({
            closeModal: types.MODAL__CLOSE_MODAL,
        }),
    },
};
</script>
